const transformSurveyResponses = (res) => res;

export default transformSurveyResponses;
